import { Environment } from '.';

export const environment: Environment = {
  production: true,
  name: 'beta',
  apiEndpoint: new URL('https://api.beta.startyoshi.com/partner/v1'),
  stripePublishableKey: 'pk_test_HcrdetnFsWge0pK6z1g78ls2',
};
